export const data = {
    obj: {
        id : 0,
        entityName : null,
        adminName : null,
        email : null,
        phoneNumber : null,
        typeCode : null,
        isApplyNewPrograms : false,
        newProgramDetails : null,
        isInterestedEmployment : false,
        isInterestedTraining : false,
        createdBy : null,
        creationDate : null,
        lastUpdatedBy : null,
        lastUpdateDate : null,
        programIds : [],
        typeId : 0,
        programId : 0,
        ProgramsOptions :[]
    },
    formValid: true,
    submitted: false,
    newProgramDetailsNotValid: false
}